import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { apiSlice } from "./apiSlice";
import modalReducer from "../features/slice/modalSlice";
import videoSliceReducer from "../components/slice/sliceSlice";
import searchSliceReducer from "../components/slice/searchSlice";
import authReducer from "../features/auth/authSlice";
import guestReducer from "../features/auth/guestSlice";

// Since reducers shouldn’t dispatch other actions directly, we can make a middleware helper to allow setCredentials to nuke the guest session safely.
// Add this middleware to store.js:
const asyncDispatchMiddleware = (store) => (next) => (action) => {
  let syncActivityFinished = false;
  let actionQueue = [];

  function flushQueue() {
    actionQueue.forEach((a) => store.dispatch(a)); // flush queued actions
    actionQueue = [];
  }

  function asyncDispatch(asyncAction) {
    actionQueue.push(asyncAction);
    if (syncActivityFinished) {
      flushQueue();
    }
  }

  const actionWithAsyncDispatch = { ...action, asyncDispatch };
  const result = next(actionWithAsyncDispatch);
  syncActivityFinished = true;
  flushQueue();
  return result;
};

export const store = configureStore({
  reducer: {
    videoSlice: videoSliceReducer,
    search: searchSliceReducer,
    modal: modalReducer,
    guest: guestReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
  },
  devTools: import.meta.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware, asyncDispatchMiddleware),
  // devTools: true,
});

setupListeners(store.dispatch);

